import ExceptionPropertiesTable from "../../../../contents/docs/error-tracking/_snippets/exception-properties-table.mdx";
import * as React from 'react';
export default {
  ExceptionPropertiesTable,
  React
};